// Exported so the shader lab can lock its camera to the SAME values
// rather than keeping a second copy that quietly drifts. The production
// camera never moves -- see ResponsiveCameraRig, which writes a scale
// factor precisely so it doesn't have to.
export const DEFAULT_CAMERA_POSITION: [number, number, number] = [0, 0, 6];
export const DEFAULT_CAMERA_FOV = 60;
